var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1),_c('SnackBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }